import React from "react";

export default function Nav() {
  return (
    <nav className="nav">
      <a href="#about">About</a>
      <a href="#projects">Projects</a>
      <a href="#resume">Resume</a>
      <a href="#contact">Contact</a>
    </nav>
  );
}